import '@yandex-int/rum-counter/dist/inline/interface.js';
import '@yandex-int/rum-counter/dist/bundle/send.js';
import '@yandex-int/error-counter/dist/implementation.js';
import '@yandex-int/error-counter/dist//filters.js';
import '@yandex-int/error-counter/dist/logError.js';
import '@yandex-int/error-counter/dist/logAjaxError.js';
import '@yandex-int/error-counter/dist/logEvent.js';
import '@yandex-int/error-counter/dist/traceUnhandledRejection.js';
import { getCookie } from './getCookie';
import { getIsMobile } from './getIsMobile';

Ya.Rum.init(
    {
        beacon: true, // использовать beacon API или нет
        clck: 'https://yandex.ru/clck/click', // хост для отправки счетчика
    },
    {
        rum_id: `ru.rythm.${getIsMobile().isMobile ? 'touch' : 'desktop'}`, // имя сервиса, первым токеном должен идти домен,
        '-blocker': '1', // признак показа под блокировщиками рекламы; если нет блокировщика - можно не передавать
    },
);

Ya.Rum.initErrors({
    project: 'rythm', // Название проекта
    page: window.location.pathname, // Страница сервиса, например: index, search, product
    /* Все, что ниже, является опциональным. Эти параметры можно не передавать, если дефолтные значения подходят */
    env: window.location.href.includes('://yandex.ru/rythm')
        ? 'production'
        : (process.env.REACT_APP_ENV as Ya.Rum.LogEnvironment), // !! Доступные значения: development, testing, prestable, production
    platform: getIsMobile().isMobile ? 'touch' : 'desktop', // !! Доступные значения: desktop, touch, pad, app, tv, tvapp, unsupported
    version: '1', // Версия [статики] вашего приложения
    yandexuid: getCookie('yandexuid'), // ID пользователя, Uint64. Логируется на уровне кликдемона из куки, можно передать вручную
    loggedin: Boolean(getCookie('yandex_login')), // Залогинен ли пользователь или нет
    referrer: true, // Можно передать либо статический url, либо функцию(которая возвращает урл в момент появления ошибки), true - передаем текущий урл(window.location.href), false - берется из referrer в кликдемоне. Пригодится когда используется [<meta name="referrer" content="origin">](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Referrer-Policy)
    blocker: true, // Наличие AdBlock, если есть детектилка AdBlock, можно сюда передать значение
    preventError: false, // Останавливает всплытие ошибки
    unhandledRejection: true, // Отлавливать Unhandled rejection
    traceUnhandledRejection: true, // Получать stacktrace для Unhandled rejection (через переопределение глобального Promise), требуется подключение `traceUnhandledRejection.js`
    uncaughtException: true, // Отлавливать непойманные события типа Error
    debug: false, // Выводить в консоль ошибки
    /* Отправлять не больше чем указанное количество ошибок каждого типа от одного пользователя */
    limits: {
        // src/implementation.js
        client: 1000,
        uncaught: 100,
        script: 100,
        external: 100,
    },
    /* На графиках выводить не больше чем указанное количество ошибок каждого типа от одного пользователя */
    silent: {
        // src/implementation.js
        client: 100,
        uncaught: 10,
        script: 10,
        external: 10,
    },
    initTimestamp: Number(new Date()), // время инита страницы с мс, можно сгенерировать на сервере. Полезно, если страницу сохранили и открывают через какой-то большой промежуток времени
});
